import { render, staticRenderFns } from "./ProfileBlockReport.vue?vue&type=template&id=2114d5b2&"
import script from "./ProfileBlockReport.vue?vue&type=script&lang=js&"
export * from "./ProfileBlockReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports